import { API } from '../constants/api-urls';
import axios from 'common/requester';
import _ from 'lodash';
// import servicesMock from './__mocks__/services.mock';

const SERVICES_ENDPOINT = API.SERVICES_PATH;

export const validateServicePathStrategy = service => {
  const pathStrategy = _.get(service, 'settings.path_strategy');
  return !!pathStrategy;
};

export const fetchServices = async () => {
  const res = await axios.get(SERVICES_ENDPOINT);
  const services = _.get(res, 'items');
  return services;
};

export const createService = async newService => {
  return await axios.post(SERVICES_ENDPOINT, newService);
};

export const updateService = async service => {
  const serviceId = _.get(service, 'id');
  if (!serviceId) throw new Error('updateService Failed: serviceId not exists');
  const updatedService = await axios.patch(
    `${SERVICES_ENDPOINT}/${serviceId}`,
    service
  );
  return updatedService;
};

export const deleteService = async serviceId => {
  return await axios.delete(`${SERVICES_ENDPOINT}/${serviceId}`);
};
